export default class Api {
  static ENDPOINT = '/api/comparison/products/';

  static #buildUrl(stockIds) {
    const root = window.location.origin;
    const url = [root, this.ENDPOINT].join('');
    const formattedStockIds = stockIds
      .map((stockId) => `"${stockId}"`)
      .join(',');

    const queryParam = `?stock-ids=[${formattedStockIds}]`;

    return `${url}${queryParam}`;
  }

  static async getProductData(stockIds = []) {
    if (!stockIds) return [];

    const endpoint = this.#buildUrl(stockIds);

    try {
      const response = await fetch(endpoint);
      const parsed = await response.json();

      return parsed;
    } catch (err) {
      return err;
    }
  }
}
